import { render } from "./attribute.vue?vue&type=template&id=6ccccf2e&scoped=true"
import script from "./attribute.vue?vue&type=script&lang=js"
export * from "./attribute.vue?vue&type=script&lang=js"

import "./attribute.vue?vue&type=style&index=0&id=6ccccf2e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ccccf2e"

export default script